import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import CustomTimePicker from '@/app/customComponents/CustomTimePicker/CustomTimePicker';
import { getStaff } from '@/app/services/staff/staff';
import { addSchedule } from '@/app/services/staff/staffschedule';
import * as Actions from '@/app/store/actions';
import { Avatar, CircularProgress, IconButton, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../staff/staff.css';

const PtoSchedules = () => {
	const dispatch = useDispatch();
	const [form, setForm] = useState({
		startTime: dayjs(new Date('', '', '', '06', '00')).format('HH:mm'),
		endTime: dayjs(new Date('', '', '', '19', '00')).format('HH:mm'),
	});
	const [errTxts, setErrTxts] = useState({});
	const [startTime, setStartTime] = useState(new Date('', '', '', '06', '00'));
	const [endTime, setEndTime] = useState(new Date('', '', '', '19', '00'));
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');
	const [searchQuery, setSearchQuery] = useState('');
	const [isStaffLoading, setIsStaffLoading] = useState(false);
	const [staff, setStaff] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		let isMounted = true;
		setIsStaffLoading(true);
		setStaff([]);
		getStaff(searchQuery, searchQuery ? undefined : 1)
			.then(({ data }) => {
				if (!isMounted) return;
				setStaff(data.data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				if (!isMounted) return;
				setIsStaffLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, [searchQuery]);

	const handleChange = ({ target }) => {
		const { name, value } = target;
		setErrTxts({ ...errTxts, [name]: '' });
		setForm({ ...form, [name]: value });
	};

	const handleTimeChange = (time, name) => {
		setErrTxts({ ...errTxts, startTime: '', endTime: '' });
		setForm({ ...form, [name]: time });
	};

	const handleSubmit = () => {
		setErrTxts({});
		if (!form.staff) {
			setErrTxts({ ...errTxts, staff: 'This field is required' });
			return;
		}
		if (!form.startDate) {
			setErrTxts({ ...errTxts, startDate: 'This field is required' });
			return;
		}
		if (form.startDate === 'Invalid Date') {
			setErrTxts({ ...errTxts, startDate: 'Please enter a valid date' });
			return;
		}
		if (form.startDate) {
			const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			const today = `${months[new Date().getMonth()]} ${new Date().getDate()} ${new Date().getFullYear()}`;
			const diff = dayjs(form.startDate).diff(dayjs(today));
			if (diff < 0) {
				setErrTxts({ ...errTxts, startDate: 'Start date can not be in the past!' });
				return;
			}
		}
		if (!form.endDate) {
			setErrTxts({ ...errTxts, endDate: 'This field is required' });
			return;
		}
		if (form.endDate) {
			const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			const today = `${months[new Date().getMonth()]} ${new Date().getDate()} ${new Date().getFullYear()}`;
			const diff = dayjs(form.endDate).diff(dayjs(today));
			if (diff < 0) {
				setErrTxts({ ...errTxts, endDate: 'End date can not be in the past!' });
				return;
			}
		}
		if (form.endDate === 'Invalid Date') {
			setErrTxts({ ...errTxts, endDate: 'Please enter a valid date' });
			return;
		}
		if (form.endDate && form.startDate) {
			const startDate = dayjs(form.startDate);
			const endDate = dayjs(form.endDate);
			const diff = endDate.diff(startDate);

			if (diff < 0) {
				setErrTxts({ ...errTxts, endDate: 'End date should not be before start date' });
				return;
			}
		}
		if (!form.startTime) {
			setErrTxts({ ...errTxts, startTime: 'This field is required' });
			return;
		}
		if (!form.endTime) {
			setErrTxts({ ...errTxts, endTime: 'This field is required' });
			return;
		}
		if (form.startTime && form.endTime) {
			const [startHour, startMinutes] = form.startTime.split(':');
			const [endHour, endMinutes] = form.endTime.split(':');
			if (startHour > endHour) {
				setErrTxts({ ...errTxts, endTime: 'End time should be greater than start time' });
				return;
			}
			if (startHour === endHour) {
				if (startMinutes >= endMinutes) {
					setErrTxts({ ...errTxts, endTime: 'End time should be greater than start time' });
					return;
				}
			}
		}

		const data = {
			teacher_id: form.staff,
			schedule_type: 'sick',
			start_date: form.startDate,
			start_time: form.startTime,
			end_date: form.endDate,
			end_time: form.endTime,
			description: form.description,
		};

		setLoading(true);
		addSchedule(data)
			.then((resp) => {
				dispatch(
					Actions.showMessage({
						message: resp.data.message,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				navigate('/staff-schedule');
			})
			.catch((err) => {
				if (err.response?.data?.errors) {
					setErrTxts(err.response.data.errors);
				} else {
					dispatch(
						Actions.showMessage({
							message: err.response.data.message,
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
				}
			})
			.finally(() => setLoading(false));
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn">
			<div className="pl-52 pt-52 pb-52 pr-52">
				<div className="text-pd-lg font-bold" style={{ fontSize: '20px', fontWeight: '700' }}>
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					Add Staff To Schedules
				</div>
				<div className="bg-white rounded mt-12 p-52">
					<span className="text-pd-lg font-bold" style={{ fontSize: '18px', fontWeight: '700' }}>
						Sick
					</span>
					<div className="grid grid-cols-2 grid-rows-2 gap-52 mt-52">
						<span className="insert-form margin-bottom">
							<Autocomplete
								autoComplete={false}
								clearOnBlur={false}
								getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
								id="staff"
								loading={isStaffLoading}
								loadingText="...Loading"
								onChange={(e, v) => {
									setErrTxts({ ...errTxts, staff: '' });
									setForm({ ...form, staff: v?.id });
								}}
								options={staff}
								renderInput={(params) => (
									<TextField
										{...params}
										autoComplete="off"
										error={errTxts.staff}
										helperText={errTxts.staff}
										label="Staff"
										onChange={(e) => setSearchQuery(e.target.value)}
										style={{ width: '100%' }}
									/>
								)}
								renderOption={(option) => (
									<div className="flex items-center" style={{ gap: 10 }}>
										<Avatar src={option.thumb} />
										<div>
											{option.first_name} {option.last_name}
										</div>
									</div>
								)}
								sx={{ width: '100%' }}
							/>
						</span>

						<div className="col-span-1 flex items-row">
							<div className="w-2.5/6 flex-grow">
								<CustomDatePicker
									disablePast
									errTxts={errTxts.startDate}
									label="Start Date"
									maxDate={form.endDate || undefined}
									setValue={(value) => {
										setErrTxts({ ...errTxts, startDate: '', endDate: '' });
										const date = value ? dayjs(value).format('YYYY-MM-DD') : '';
										setStartDate(date);
										setForm({ ...form, startDate: date });
									}}
									value={startDate}
									width="100"
								/>
							</div>
							<div className="w-1/6 text-center flex-grow" style={{ lineHeight: '50px' }}>
								<span className="m-auto">to</span>
							</div>
							<div className="w-2.5/6 flex-grow">
								<CustomDatePicker
									disablePast
									errTxts={errTxts.endDate}
									label="End date"
									minDate={form.startDate || undefined}
									setValue={(value) => {
										setErrTxts({ ...errTxts, startDate: '', endDate: '' });
										const date = value ? dayjs(value).format('YYYY-MM-DD') : '';
										setEndDate(date);
										setForm({ ...form, endDate: date });
									}}
									value={endDate}
									width="100"
								/>
							</div>
						</div>
						<div className="col-span-1 flex items-row">
							<div className="w-2.5/6 flex-grow">
								<CustomTimePicker
									errTxts={errTxts}
									handleTimeChange={handleTimeChange}
									label="Start Time"
									name="startTime"
									setValue={setStartTime}
									value={startTime}
									width="100%"
								/>
							</div>
							<div className="w-1/6 text-center flex-grow" style={{ lineHeight: '50px' }}>
								<span className="m-auto">to</span>
							</div>
							<div className="w-2.5/6 flex-grow">
								<CustomTimePicker
									errTxts={errTxts}
									handleTimeChange={handleTimeChange}
									label="End Time"
									name="endTime"
									setValue={setEndTime}
									value={endTime}
									width="100%"
								/>
							</div>
						</div>
						<div className="col-span-1">
							<TextField
								className="w-full"
								error={errTxts.description}
								helperText={errTxts.description}
								label="Description"
								name="description"
								onChange={handleChange}
							/>
						</div>
					</div>
					{isLoading ? (
						<div className="flex justify-center my-24">
							<CircularProgress className="mx-auto" />
						</div>
					) : (
						<div className="flex justify-center mt-64 mb-64">
							<span style={{ marginRight: '5px' }}>
								<CustomButton
									marginRight="11px"
									onClick={() => {
										navigate('/staff-schedule');
									}}
									variant="secondary"
									width={140}
								>
									Cancel
								</CustomButton>

								<CustomButton onClick={handleSubmit} variant="primary" width={140}>
									Save
								</CustomButton>
							</span>
						</div>
					)}
				</div>
			</div>
		</FuseAnimate>
	);
};

export default PtoSchedules;
